import { render } from "./InputPhone.vue?vue&type=template&id=814ebb10&scoped=true"
import script from "./InputPhone.vue?vue&type=script&lang=js"
export * from "./InputPhone.vue?vue&type=script&lang=js"

import "./InputPhone.vue?vue&type=style&index=0&id=814ebb10&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814ebb10"]])

export default __exports__